<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.code-panne.panne')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :id="$options.name" :can-open="canOpen">
        <template v-slot:close>
            <template v-if="selected">
                <template v-if="getDataByKey('code_symptome', 'selected')">
                    <div class="font-bold">{{$t('form.code-panne.que_se_passe_t_il')}}</div>
                    <div class="mt-1 text-xs font-light">{{getDataByKey('code_symptome', 'selected').value.libelle}}</div>
                </template>
                <template v-if="getDataByKey('code_condition', 'selected')">
                    <div class="pt-4 mt-4 font-bold border-t border-gray-200">{{$t('form.code-panne.dans_quelle_condition')}}</div>
                    <div class="mt-1 text-xs font-light">{{getDataByKey('code_condition', 'selected').value.libelle}}</div>
                </template>
                <template v-if="getDataByKey('description', 'selected')">
                    <div class="font-bold border-gray-200" :class="getDataByKey('code_symptome', 'selected') || getDataByKey('code_condition', 'selected') ? 'pt-4 mt-4 border-t' : ''">{{$t('form.code-panne.description_de_la_panne')}}</div>
                    <div class="mt-1 text-xs font-light">{{getDataByKey('description', 'selected').value}}</div>
                </template>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            <template v-if="!loading">
                <sav-form v-if="data" class="mt-2" :data-src="data" :callback="end" :id="$options.name" :can-submit="canSubmit" />
            </template>
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'code-panne',
    extends: FormCardExtension,

    data() {
        return {
            canSubmit: false,
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                let localStorageData = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = await this.getNextBlock()
                this.selected = localStorageData
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.data = []

            // Check code panne
            let codeSymptome = null
            let responseCodePanne = await apiService.post('getcodesymptome', {
                id_app: this.$formTool.getFormData('device')[0].value.id
            })
            if (responseCodePanne.data.posts.code_symptome && responseCodePanne.data.posts.code_symptome.length > 0) {
                codeSymptome = responseCodePanne.data.posts.code_symptome
                codeSymptome.forEach((item) => {
                    item.libelle = this.$tt(item.libelle)
                })
                console.log(codeSymptome);
            }

            if (codeSymptome) {
                this.data.push({
                    testId: 'code-symptome',
                    displayLabel: true,
                    label: this.$t('form.code-panne.que_se_passe_t_il'),
                    type: 'select',
                    key: 'code_symptome',
                    onChange: this.callbackSymptome,
                    options: {
                        label: 'libelle',
                        values: codeSymptome.map(code => ({
                            ...code,
                        })),
                    },
                    value: this.selected ? this.getDataByKey('code_symptome', 'selected').value : null,
                    required: true
                })
                if (this.getDataByKey('code_symptome', 'selected')) {
                    this.getCodeCondition()
                    this.canSubmit = true
                }
            } else {
                this.canSubmit = true
            }

            this.data.push({
                type: 'textarea',
                label: this.$t('form.code-panne.description_de_la_panne'),
                displayLabel: true,
                required: true,
                key: 'description',
                api_key: 'description',
                value: this.$formTool.getFormData(this.$options.name) ? this.$formTool.getFormData(this.$options.name).find(el => el.api_key == 'description').value : null,
                errors: []
            })

            this.loading = false
        },

        async end(callbackData) {
            let descInp = this.data.find((item) => item.key == 'description')
            if (!descInp.value || descInp.value.trim().length <= 15) {
                descInp.errors.push(this.$tt("Le champ doit faire au moins 15 caractères"))
                return
            } else {
                descInp.errors = []
            }
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$formTool.removeFormData('tchat-key')
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        async getCodeCondition() {
            // if (this.data.length > 2) {
            //     this.data.splice(1, 1);
            // }

            let responseCodeCondition = await apiService.post('getcodecondition', {
                id_app: this.$formTool.getFormData('device')[0].value.id,
                code_symptome: this.getDataByKey('code_symptome').value.code
            })
            let codeCondition = responseCodeCondition.data.posts.code_condition
            if (codeCondition && codeCondition.length > 0) {
                let formObj = {
                    testId: 'code-condition',
                    displayLabel: true,
                    label: this.$t('form.code-panne.dans_quelle_condition'),
                    type: 'select',
                    key: 'code_condition',
                    onChange: this.callbackCondition,
                    options: {
                        label: 'libelle',
                        values: codeCondition.map(code => ({
                            ...code,
                        })),
                    },
                    value: this.selected ? this.getDataByKey('code_condition', 'selected').value : null,
                    required: true
                }
                Array.prototype.insert = function (index, ...items) {
                    this.splice(index, 0, ...items)
                };
                if (this.data.find((item) => item.key == 'code_condition')) {
                    this.data.splice(1, 1)
                }
                this.data.insert(1, formObj)
            } else {
                this.canSubmit = true
            }
        },

        async getBdc() {
            let data = {
                id_app: this.$formTool.getFormData('device')[0].value.id,
            }

            if (this.getDataByKey('code_condition')) {
                data.code_condition = this.getDataByKey('code_condition').value.code
            }
            if (this.getDataByKey('code_symptome')) {
                data.code_symptome = this.getDataByKey('code_symptome').value.code
            }
            let responseBdc = await apiService.post('getbdc', data)
            return responseBdc.data.posts
        },
        async getBdc2() {
            let data = {id_app: this.$formTool.getFormData('device')[0].value.id,}

            if (this.getDataByKey('code_condition')) {
                data.code_condition = this.getDataByKey('code_condition').value.code
            }
            if (this.getDataByKey('code_symptome')) {
                data.code_symptome = this.getDataByKey('code_symptome').value.code
            }
            let responseBdc = await apiService.post('getbdc2', data)
            return responseBdc.data.posts
        },

        async getNextBlock() {
            // PANSEMENT CARREFOUR
            if (this.$formTool.getFormData('purchase-date') && this.$formTool.blockData(this.$options.name).next.afterSaleReceipt) {
                return this.$formTool.blockData(this.$options.name).next.afterSaleReceipt
            }

            // Tchat
            let bdc = await this.getBdc()
            this.$formTool.addFormData('bdc', bdc)
            if (bdc.spareka == 1) {
                this.$formTool.addFormData('spareka-keyword', bdc.categ_spareka)
                return this.$formTool.blockData(this.$options.name).next.spareka
            }
            if (bdc.post && bdc.post.length > 0) {
                let bdc2 = await this.getBdc2()
                this.$formTool.addFormData('bdc2', bdc2)
                if (this.$companyTool.confFile().chatbot == '1') {
                    return this.$formTool.blockData(this.$options.name).next.newOwnTchat
                } else {
                    return this.$formTool.blockData(this.$options.name).next.ownTchat
                }
            }
            
            // Online
            let response = await apiService.post('buyonline', {
                id_app: this.$formTool.getFormData('device')[0].value.id
            })
            if (response.data.posts.post == 1) {
                return this.$formTool.blockData(this.$options.name).next.buyOnline
            }

            // Shop
            if (this.$formTool.getFormData('sign')) {
                return this.$formTool.blockData(this.$options.name).next.continueShop
            } else {
                return this.$formTool.blockData(this.$options.name).next.continue
            }
        },

        callbackSymptome() {
            this.$nextTick(() => {
                if (this.data[0].value) {
                    this.getCodeCondition()
                }
            })
        },

        callbackCondition(data) {
            this.$nextTick(() => {
                if (this.data[1].value) {
                    this.canSubmit = true
                } else {
                    this.canSubmit = false
                }
            })
        },

        getDataByKey(key, variable = 'data') {
            if (this[variable]) {
                return this[variable].find((item) => item.key == key)
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/CodePanneCard.vue